import { render, staticRenderFns } from "./DACalendar.vue?vue&type=template&id=23be6652"
import script from "./DACalendar.vue?vue&type=script&lang=js"
export * from "./DACalendar.vue?vue&type=script&lang=js"
import style0 from "./DACalendar.vue?vue&type=style&index=0&id=23be6652&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports